import { publicRoutes, commonRoutes } from './public';
import { protectedRoutes } from './protected';
import { observer } from 'mobx-react-lite';
import { Navigate, Route, Routes } from 'react-router-dom';
import { DASHBOARD, SIGN_IN } from './paths';
import LanguageWrapper from '../features/LanguageWrapper';
import useCurrentLanguage from '@/shared/hooks/useCurrentLanguage';
import { useStore } from '../app/store';
import { Suspense, type ReactElement } from 'react';
import { ClipLoader } from 'react-spinners';

// import useLanguage from '@/shared/hooks/useLanguage';
// import Navbar from '@/widgets/layout/navbar/Navbar';

interface GuardProps {
  element: ReactElement;
}

const RouteFallback = () => (
  <div className='route-loader' role='status' aria-live='polite'>
    <div className='route-loader__card'>
      <ClipLoader size={34} color='#1598d8' />
      <span>Загружаем страницу</span>
    </div>
  </div>
);

const ProtectedRoute = observer(({ element }: GuardProps) => {
  const store = useStore();

  const lng = useCurrentLanguage();
  const defaultLanguage = 'ru';
  const languagePrefix = lng !== defaultLanguage ? `/${lng}` : '';
  const navigatePath = `/${languagePrefix}/${SIGN_IN}`.replace(/\/+/g, '/');
  return store.isAuth ? element : <Navigate to={navigatePath} replace />;
});

const PublicRoute = observer(({ element }: GuardProps) => {
  const store = useStore();
  return store.isAuth ? <Navigate to={`/${DASHBOARD}`} replace /> : element;
});

const AppRoutes = () => {
  return (
    <Suspense fallback={<RouteFallback />}>
    <Routes>
      <Route path='/:lng?/*' element={<LanguageWrapper />}>
        {protectedRoutes.map((route, index) => (
          <Route
            key={`protected-${index}`}
            path={route.path}
            element={<ProtectedRoute element={route.element} />}
          >
            {route.children &&
              route.children.map((childRoute, childIndex) => (
                <Route
                  key={childIndex}
                  index={childRoute.index}
                  path={childRoute.path}
                  element={<ProtectedRoute element={childRoute.element} />}
                />
              ))}
          </Route>
        ))}
        {publicRoutes.map((route, index) => (
          <Route
            key={`public-${index}`}
            path={route.path}
            element={<PublicRoute element={route.element} />}
          />
        ))}
        {commonRoutes.map((route, index) => (
          <Route
            key={`common-${index}`}
            path={route.path}
            element={route.element}
          />
        ))}
      </Route>
    </Routes>
    </Suspense>
  );
};

export default observer(AppRoutes);
